import type { WebsiteAgentSuggestion } from "~/lib/marketplace/website-suggestions";
import {
  buildRecommendedAgentPersona,
  buildRecommendedAgentProfile,
  DEFAULT_HIRE_INTEGRATIONS,
} from "~/lib/marketplace/website-suggestions";
import { buildOnboardingGoalsFromWebsite } from "~/lib/marketplace/hire-builder-onboarding";

export const HIRE_WEBSITE_SUGGESTION_KEY = "egpt-hire-website-suggestion";

export function writeWebsiteSuggestion(suggestion: WebsiteAgentSuggestion): void {
  if (typeof window === "undefined") return;
  try {
    const raw = JSON.stringify(suggestion);
    sessionStorage.setItem(HIRE_WEBSITE_SUGGESTION_KEY, raw);
    localStorage.setItem(HIRE_WEBSITE_SUGGESTION_KEY, raw);
  } catch {
    /* ignore */
  }
}

export function readWebsiteSuggestion(): WebsiteAgentSuggestion | null {
  if (typeof window === "undefined") return null;
  try {
    const raw =
      sessionStorage.getItem(HIRE_WEBSITE_SUGGESTION_KEY) ||
      localStorage.getItem(HIRE_WEBSITE_SUGGESTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as WebsiteAgentSuggestion;
    if (!parsed.recommendations) {
      parsed.recommendations = {
        agentProfile: {
          ...buildRecommendedAgentProfile(parsed.vertical, parsed.businessName),
          persona: buildRecommendedAgentPersona(
            buildRecommendedAgentProfile(parsed.vertical, parsed.businessName).agentName,
            buildRecommendedAgentProfile(parsed.vertical, parsed.businessName).jobTitle,
            parsed.businessName,
          ),
        },
        skills: ["Live Chat", "Team Handoff"],
        integrations: [...DEFAULT_HIRE_INTEGRATIONS],
        emrIntegration: null,
        appointmentsScheduling: ["Google Calendar"],
        locations: "1 location (main office)",
        locationList: [],
        teamMembers: "Lead Team Member + Account Owner",
      };
    }
    const rec = parsed.recommendations;
    if (rec) {
      if (!rec.agentProfile?.persona && rec.agentProfile) {
        rec.agentProfile = {
          ...rec.agentProfile,
          persona: buildRecommendedAgentPersona(
            rec.agentProfile.agentName,
            rec.agentProfile.jobTitle,
            parsed.businessName,
          ),
        };
      } else if (!rec.agentProfile) {
        const profile = buildRecommendedAgentProfile(parsed.vertical, parsed.businessName);
        rec.agentProfile = {
          ...profile,
          persona: buildRecommendedAgentPersona(
            profile.agentName,
            profile.jobTitle,
            parsed.businessName,
          ),
        };
      }
      if (!rec.integrations?.length) {
        rec.integrations = [...DEFAULT_HIRE_INTEGRATIONS];
      }
      if (rec.emrIntegration === undefined) {
        rec.emrIntegration = null;
      }
    }
    if (!parsed.onboardingGoalSuggestions?.length && parsed.vertical) {
      parsed.onboardingGoalSuggestions = buildOnboardingGoalsFromWebsite(
        parsed.vertical,
        `${parsed.businessName ?? ""} ${parsed.summary ?? ""} ${parsed.categoryLabel ?? ""}`,
        parsed.businessName,
      );
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearWebsiteSuggestion(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(HIRE_WEBSITE_SUGGESTION_KEY);
    localStorage.removeItem(HIRE_WEBSITE_SUGGESTION_KEY);
  } catch {
    /* ignore */
  }
}
